import {
  ArchiveBoxIcon,
  CommandLineIcon,
  LockClosedIcon,
  MusicalNoteIcon,
  ServerStackIcon,
  StarIcon,
} from "@heroicons/react/24/outline";

export const ProjectsIntro = ({
  authenticatedResources,
  setProjectIdentifier,
}) => {
  return (
    <div className="flex flex-col items-center justify-center flex-grow px-4 py-5 sm:p-6">
      <h1 className="text-gray-700 text-2xl font-bold p-2 mb-4 w-full">
        Interactive Project Viewer
      </h1>
      {/* Bento Box Layout */}
      <div className="w-full max-w-2xl">
        {/* Top 2x2 grid */}
        <div className="grid grid-cols-5 grid-rows-2 gap-0 h-36 rounded-t-2xl overflow-hidden shadow">
          {/* Whenfin: spans left 2 columns and both rows */}
          <button
            className="relative row-start-1 row-end-3 col-start-1 col-end-4 bg-white border-2 border-gray-200 flex items-center justify-center font-bold text-3xl hover:border-indigo-400 transition"
            onClick={() =>
              setProjectIdentifier && setProjectIdentifier("Whenfin")
            }
            style={{
              borderTopLeftRadius: "1rem",
            }}
          >
            <StarIcon className="top-2 right-2 text-amber-500 fill-amber-500 h-5 w-5 absolute" />
            <img
              src={require("./assets/whenfin.png")}
              alt="Whenfin"
              className="w-36 h-36 mr-3 absolute -left-6 -bottom-14 opacity-30"
            />
            Whenfin
          </button>
          {/* Loopster: top right cell */}
          <button
            className="row-start-1 row-end-2 col-start-4 col-end-6 text-indigo-500 flex items-center justify-center font-bold text-xl gap-2 transition border-2 hover:border-indigo-500 relative overflow-hidden"
            onClick={() =>
              setProjectIdentifier && setProjectIdentifier("Loopster")
            }
            style={{ borderTopRightRadius: "1rem" }}
          >
            {/* Blurred amorphous blobs background */}
            <div className="absolute inset-0 z-10 w-full h-full pointer-events-none">
              {/* Blue blob (top left) */}
              <div
                className="absolute top-[-30%] left-[-10%] w-1/3 h-2/3 rounded-full"
                style={{
                  background: "#5d51ff",
                  opacity: 0.25,
                  filter: "blur(12px)",
                }}
              />
              {/* Coral red blob (bottom right) */}
              <div
                className="absolute bottom-[0%] right-[-50%] w-2/3 h-full rounded-full"
                style={{
                  background: "#f84e95",
                  opacity: 0.3,
                  filter: "blur(12px)",
                }}
              />
              {/* Coral red blob (bottom right) */}
              <div
                className="absolute bottom-[-60%] left-[30%] w-1/3 h-full rounded-full"
                style={{
                  background: "rgba(255, 127, 127, 0.32)",
                  filter: "blur(12px)",
                }}
              />
            </div>
            <MusicalNoteIcon className="h-5 w-5" />
            Loopster
          </button>
          {/* Blackbox: bottom right cell */}
          <button
            className="row-start-2 relative row-end-3 col-start-4 bg-slate-900 font-mono col-end-6 flex items-center justify-center font-bold text-xl border-2 border-slate-900 transition hover:border-indigo-500"
            onClick={() =>
              setProjectIdentifier && setProjectIdentifier("Blackbox")
            }
          >
            <div className="absolute block p-1 top-2 right-2 z-10 rounded security-cam-tick" />
            <span style={{ color: "#e2a76f" }}>Blackbox</span>
          </button>
        </div>
        {/* Bottom 5x1 grid */}
        <div
          className={
            "grid grid-cols-5 gap-0 h-24 rounded-b-2xl overflow-hidden shadow" +
            (!authenticatedResources ? " striped-disabled-bg" : " bg-gray-50")
          }
        >
          {/* File Compressor: left 2/5 */}
          <button
            className="overflow-hidden col-start-1 gap-2 col-end-3 border-2 border-gray-200 flex items-center justify-center font-bold text-lg hover:border-indigo-400 transition"
            onClick={() =>
              setProjectIdentifier && setProjectIdentifier("FileCompressor")
            }
            style={{ borderBottomLeftRadius: "1rem" }}
          >
            {authenticatedResources ? (
              <div className="relative w-6 h-6 flex items-center justify-center">
                {/* Rod animation */}
                <span className="absolute left-1/2 -z-1 -top-8 -translate-x-1/2 w-1 h-36 bg-indigo-300 animate-rod-drop" />
                {/* Dot animation */}
                <span className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-2 h-2 rounded-full bg-indigo-300 animate-dot-drop" />
                <CommandLineIcon className="w-6 h-6 bg-gray-50 compressor-shake z-10" />
              </div>
            ) : (
              <LockClosedIcon className="w-6 h-6" />
            )}
            File Compressor
          </button>
          {/* HPC Management: right 3/5 */}
          <button
            className={`relative col-start-3 col-end-6 gap-2 border-2 border-gray-200 flex items-center justify-center font-bold text-lg hover:border-indigo-400 transition ${
              authenticatedResources ? "bg-white" : ""
            }`}
            onClick={() =>
              setProjectIdentifier &&
              setProjectIdentifier("DistributedComputing")
            }
            style={{ borderBottomRightRadius: "1rem" }}
          >
            {authenticatedResources ? (
              <>
                <StarIcon className="top-2 right-2 text-amber-500 fill-amber-500 h-5 w-5 absolute" />
                <ServerStackIcon className="w-7 h-7" />
              </>
            ) : (
              <LockClosedIcon className="w-6 h-6" />
            )}
            HPC Management
          </button>
        </div>
      </div>
    </div>
  );
};
